import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRole } from "./MangeContextProvide";
import { axiosInstance } from "../utility/apiInstance";
import Loading from "./AWBDashboard/Loading";
import { SocketProvider } from "../context/SocketContext";

const ProtectedLayout: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const {
    setGlobleCustomerId,
    role,
    loading,
    setLoading,
    setRole,
    setOrganizationId,
    unreadCount,
    setModule,
    setGlobalData,
    setIsWebhookAllowed,
    setGrouppedByPrefrence
  } = useRole() as any;

  const navigate = useNavigate();
  const [isClient, setIsClient] = useState(false);
  const [token, setToken] = useState<string | null>(null);
  useEffect(() => {
    document.title = unreadCount > 0 ? `CD Track (${unreadCount})` : "CD Track";
  }, [unreadCount]);
  const getCustomerAuth = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/api/v1/customers-auth");
  
      const grouppedByRes={
        customFieldByPrefrence:response?.data?.data?.customFieldByPrefrence||"",
        grouppedByPrefrence:response?.data?.data?.grouppedByPrefrence||""
      }
      setLoading(false);
      setRole(response?.data?.data?.role);
      setGrouppedByPrefrence(grouppedByRes);
      setGlobleCustomerId(response?.data?.data?._id);
      setOrganizationId(response?.data?.data?.organisationId?._id);
      if (response?.data?.data?.role === "customeruser"||response?.data?.data?.role === "groundstaff") {
        setModule(response?.data?.data?.module);
        setGlobalData(response?.data?.data?.globalData);
      } else if (response?.data?.data?.role === "customeradmin") {
        setModule(response?.data?.data?.organisationId?.module);
        setIsWebhookAllowed(response?.data?.data?.organisationId?.isWebhookAllowed);
      }
    } catch (err) {
      setLoading(false);
    }
  };
const storedToken = localStorage.getItem("token");
  useEffect(() => {
    setIsClient(true);
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
      getCustomerAuth();
    } else {
      navigate("/");
    }
  }, []);

  if (loading) {
    return <Loading />;
  }

  if (!token || role === "") {
    navigate("/auth/login");
    return null;
  }

  return <SocketProvider token={storedToken}>{children}</SocketProvider>;
};

export default ProtectedLayout;
